var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 7.66663L16.7126 9.56242C14.8101 10.6193 13.8588 11.1479 12.8514 11.3551C11.9598 11.5384 11.0402 11.5384 10.1486 11.3551C9.1412 11.1479 8.18995 10.6193 6.28743 9.56242L2.875 7.66663M5.94167 18.2083H17.0583C18.1318 18.2083 18.6685 18.2083 19.0785 17.9994C19.4391 17.8157 19.7324 17.5224 19.9161 17.1618C20.125 16.7518 20.125 16.2151 20.125 15.1416V7.85829C20.125 6.78486 20.125 6.24814 19.9161 5.83815C19.7324 5.4775 19.4391 5.18428 19.0785 5.00053C18.6685 4.79163 18.1318 4.79163 17.0583 4.79163H5.94167C4.86824 4.79163 4.33151 4.79163 3.92152 5.00053C3.56087 5.18428 3.26766 5.4775 3.08391 5.83815C2.875 6.24814 2.875 6.78485 2.875 7.85829V15.1416C2.875 16.2151 2.875 16.7518 3.08391 17.1618C3.26766 17.5224 3.56087 17.8157 3.92152 17.9994C4.33151 18.2083 4.86823 18.2083 5.94167 18.2083Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.d13bb092534dcdcc1535564b2038d3ca.svg";
export { ForwardRef as ReactComponent };